<template>

  <div class="home-page-top">

    <div class="home-welcome">
      <div class="welcome-name">
        <!-- Hi,Osman -->
        <v-tooltip :text="'Hi,' + userStore.name" location="top">
          <template #activator="{ props }">
            <div v-bind="props">
              Hi,{{ userStore.name }}
            </div>
          </template>
          <!-- <span>Hi,{{ userStore.name }}</span> -->
        </v-tooltip>
      </div>
      <div class="welcom-subtitle">欢迎来到奇点智慧储能云平台</div>
    </div>

    <div class="home-top-right">
      <!-- <div v-if="role == 'operation'"
        style="width: 120px;margin-left: 16px; margin-bottom: 12px; align-self: flex-end;">
        <v-select v-model="selectedArea" class="region-select" placeholder="按区域" variant="outlined" density="compact"
          rounded clearable :items="['东北', '华中', '华南', '西南', '西北']" hide-details></v-select>
      </div> -->
      <TopStatus />
      <TopMenu :menus="menus" />
    </div>

  </div>
</template>



<script setup>
import { ref } from 'vue';

import ChatBoxBody from '@/components/ChatBoxBody/index.vue'
import TopStatus from './TopStatus/index.vue'
import TopMenu from './TopMenu/index.vue'

import useUserStore from '@/store/modules/user'

const userStore = useUserStore()



const props = defineProps({
  menus: {
    type: Array,
    default: () => []
  }
})

</script>





<style lang="scss" scoped>

.home-page-top {
  height: 80px;
  display: flex;
  justify-content: space-between;
  // background: rgba($color: #E6F3FF, $alpha: 0.5);
  padding: 8px 16px;
}


.welcome-name {
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  // line-height: 67px;
  font-family: "Gotham";
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 400px;
}

.home-welcome {
  width: 440px;
}

.home-top-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.welcom-subtitle {
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  color: #2E2E2E;
}
</style>
